import angular from "angular";
import _ from "lodash";
import axios from "axios";
import * as actions from "../../store/actions";
import { message, Modal } from "antd";

angular.module("webTools").directive("wtDroppable", [
	"$rootScope",
	"$compile",
	"$timeout",
	"ModalWindow",
	"Utility",
	"DropHandler",
	"$ngRedux",
	"$location",
	function (
		$rootScope,
		$compile,
		$timeout,
		ModalWindow,
		Utility,
		DropHandler,
		$ngRedux,
		$location
	) {
		return {
			link: function (scope, element) {
				const store = $ngRedux.getState();

				let el = element[0];
				let enterRow = null;
				let enterTarget = null;
				let folderName = null;
				let folderId = null;

				var newScope = $rootScope.$new();
				newScope.visible = false;
				newScope.folderName = "";

				var elx = $compile(
					'<drop-overlay visible="visible" folder-name="folderName"></drop-overlay>'
				)(newScope);

				element.append(elx);

				$(el).find(".k-grid-content table").css("border-collapse", "collapse");

				element.append(
					`<div id="overlay" class="hidden" style="font-size: 18px;font-weight: bold;pointer-events:none"></div>`
				);

				el.addEventListener(
					"dragover",
					function (e) {
						
						e.preventDefault();
						e.stopPropagation();

						if((store.app.webViewMode || store.user.readOnly) || ($rootScope.workingFolder === 'favorites' || $rootScope.workingFolder === 'recyclebin')) {
							e.dataTransfer.dropEffect = "none";
							return false;
						}

						e.dataTransfer.dropEffect = "copy";
						return false;
					},
					false
				);

				let hoverTimeout;

				el.addEventListener(
					"dragenter",
					function (e) {

						if($rootScope.workingFolder === 'favorites' || $rootScope.workingFolder === 'recyclebin') {
							return;
						}

						e.preventDefault();
						e.stopPropagation();

						if(store.app.webViewMode || store.user.readOnly) {
							e.dataTransfer.dropEffect = "none";
							return false;
						}

						enterRow = null;

						const breadcrumbItem = $(e.target).parent().is(".breadcrumb-item");
						const gridRow = $(e.target).closest("tr")[0];

						if (gridRow) {
							var uid = angular.element(gridRow).attr("data-uid");

							enterRow = gridRow;

							var row = _.find(
								scope.kendo[scope.gridName]._data,
								function (ds) {
									return ds.uid === uid;
								}
							);

							if (row && row.ObjectType === "fod") {
								folderId = row.ID;
								folderName = row.FileName;

								$(gridRow).css("box-shadow", "0 0 10px #ccc");
								$(gridRow).css("color", "#000");
								$(gridRow).css("font-weight", "bold");
							} else {
								folderId = $rootScope.workingFolder;
								folderName = $rootScope.workingFolderName;
							}
						} else if (breadcrumbItem) {
							const bc = $(e.target).parent();

							$(bc)
								.children()
								.css("border-bottom", "2px dashed var(--primary)");
							$(bc).children().css("color", "#000");

							folderId = bc.attr("data-id");
							folderName = bc.attr("data-name");

							hoverTimeout = setTimeout(() => {
								$location.url(`/documents?folder=${folderId}`);
								scope.$apply();
							}, 2000);
						} else {
							folderId = $rootScope.workingFolder;
							folderName = $rootScope.workingFolderName;
						}

						angular.element("#overlay").addClass("drop-overlay");
						newScope.folderName = folderName;
						newScope.$apply();

						newScope.visible = true;
						newScope.$apply();

						enterTarget = e.target;

						return false;
					},
					false
				);

				el.addEventListener(
					"dragleave",
					function (e) {
						e.preventDefault();
						e.stopPropagation();

						if(store.app.webViewMode || store.user.readOnly) {
							e.dataTransfer.dropEffect = "copy";
							return false;
						}

						const gridRow = $(e.target).closest("tr")[0];
						var uid = angular.element(gridRow).attr("data-uid");
						var row = _.find(scope.kendo[scope.gridName]._data, function (ds) {
							return ds.uid === uid;
						});

						const breadcrumbItem = $(e.target).parent().is(".breadcrumb-item");

						if (row && row.ObjectType === "fod" && gridRow !== enterRow) {
							$(gridRow).css("box-shadow", "none");
							$(gridRow).css("color", "#444");
							$(gridRow).css("font-weight", "normal");
						} else if (breadcrumbItem) {
							clearTimeout(hoverTimeout);
							const bc = $(e.target).parent();
							$(bc).children().css("border", "1px solid #fff");
							$(bc).children().css("color", "#00000073");
						}

						if (enterTarget === e.target) {
							newScope.visible = false;
							newScope.$apply();
							$(gridRow).css("box-shadow", "none");
							$(gridRow).css("color", "#444");
							$(gridRow).css("font-weight", "normal");

							angular.element("#overlay").removeClass("drop-overlay");
							return false;
						}
					},
					false
				);

				el.addEventListener(
					"drop",
					async function (e) {

						if($rootScope.workingFolder === 'favorites' || $rootScope.workingFolder === 'recyclebin') {
							return;
						}

						if (e.stopPropagation) e.stopPropagation();
						e.preventDefault();

						// get dropped files
						const files = await DropHandler.getFiles(e.dataTransfer);

						// check permissions
						const { data: permissions } = await axios.post(
							"/api/documents/getPermissions",
							{ folderId: folderId }
						);

						const afterDrop = () => {
							angular.element("#overlay").removeClass("drop-overlay");
							newScope.visible = false;
							newScope.$apply();

							const breadcrumbItem = $(e.target)
								.parent()
								.is(".breadcrumb-item");
							const gridRow = $(e.target).closest("tr")[0];
							var uid = angular.element(gridRow).attr("data-uid");
							var row = _.find(
								scope.kendo[scope.gridName]._data,
								function (ds) {
									return ds.uid === uid;
								}
							);

							if (row && row.ObjectType === "fod") {
								folderId = row.ID;
								folderName = row.FileName;

								$(gridRow).css("box-shadow", "none");
								$(gridRow).css("color", "#444");
								$(gridRow).css("font-weight", "normal");
							} else if (breadcrumbItem) {
								clearTimeout(hoverTimeout);

								const bc = $(e.target).parent();

								$(bc).children().css("border-bottom", "none");
								$(bc).children().css("color", "#00000e0");

								folderId = bc.attr("data-id");
								folderName = bc.attr("data-name");
							} else {
								enterRow = null;
								folderId = $rootScope.workingFolder;
								folderName = $rootScope.workingFolderName;
							}
						};

						let noPerms = false;
						const { addData, allowImport } = permissions;

						if (addData == 0 || allowImport == 0) {
							afterDrop();

							let errorMessage = "";
							if (addData == 0) {
								errorMessage = "You do not have permission to import files to:";
							}
							if (allowImport == 0) {
								errorMessage = "This folder does not allow importing files:";
							}

							Modal.error({
								title: "Import Not Allowed",
								content: (
									<div>
										{errorMessage}
										<div style={{ marginTop: "5px" }}>
											<strong>{folderName}</strong>
										</div>
									</div>
								),
								centered: true,
							});
							noPerms = true;
						}

						var openDialog = function (errorMessage) {
							afterDrop();

							if (errorMessage !== "") {
								ModalWindow.openNotification(errorMessage);
								return false;
							} else {
								const modalOptions = {
									title: `Import to: ${folderName}`,
									width: 1000,
									responsive: true,
									styles: { body: { height: 550 } },
									maskClosable: false,
									footer: null,
								};

								$ngRedux.dispatch(
									actions.showModal("IMPORT", modalOptions, {
										files: files,
										importFolder: { id: folderId, name: folderName },
									})
								);
							}
						};

						$timeout(function () {
							!noPerms && scope.checkFileSize(files, openDialog);
						});

						return false;
					},
					false
				);

				scope.checkFileSize = function (files, callback) {
					var errorString = "";

					/* eslint-disable  no-unused-vars */
					var foundFolder = false;
					var isFile = false;
					/* eslint-enable  no-unused-vars */

					if (files.length === 0) {
						callback("Dropped folder contains no files.");
						return;
					} else if (Utility.checkForIE() !== false) {
						callback("");
						return;
					}

					_.each(files, function (file) {
						if (file.size > store.app.maxFileSize * 1024) {
							errorString =
								"<strong>" +
								file.name +
								"</strong> exceeds maximum allowed file size.";
							return false;
						}
					});

					$timeout(function () {
						callback(errorString);
					}, 1);
				};
			},
		};
	},
]);
